'use client'
import { useState, useEffect } from 'react'

// Define breakpoint values (matching Ant Design's defaults)
const breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
}

type Breakpoint = keyof typeof breakpoints
type BreakpointMap = Partial<Record<Breakpoint, boolean>>

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>('lg')
  const [screens, setScreens] = useState<BreakpointMap>({})

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      
      // Find the current breakpoint
      let currentBreakpoint: Breakpoint = 'xs'
      const currentScreens: BreakpointMap = {}
      
      for (const [key, value] of Object.entries(breakpoints)) {
        const matches = width >= value
        currentScreens[key as Breakpoint] = matches
        if (matches) {
          currentBreakpoint = key as Breakpoint
        }
      }

      setBreakpoint(currentBreakpoint)
      setScreens(currentScreens)
    }

    // Initial check
    handleResize()

    // Add event listener
    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    breakpoint,
    screens,
  }
} 